/**
 * Created by decipaliz on 23.05.2024
 */

const PrizeCalendarMissionLogic = function (mission) {
    this.mission = mission;

    this.checkCompletion();

    if (this.mission.isRunning()) {
        this.mission.logEvent(Mission.EVENTS.MISSION_STAGE, { itemId: `${this.mission.result}`, once: true });
    }
};

PrizeCalendarMissionLogic.prototype.getTilesAmount = function () {
    return RewardsConfig.PrizeCalendar.stages.length;
};

PrizeCalendarMissionLogic.prototype.checkCompletion = function () {
    if (this.mission.result >= this.getTilesAmount()) {
        this.mission.logEvent(Mission.EVENTS.MISSION_FINISH, { once: true });
        this.mission.complete();
    }
};

PrizeCalendarMissionLogic.prototype.isAttentionRequired = function () {
    return this.mission.result === 0;
};

PrizeCalendarMissionLogic.prototype.onComplete = function () {
    cleverapps.metrics.logEvent(cleverapps.EVENTS.PRIZECAL_COMPLETE);
};